import { makeStyles, alpha } from "@material-ui/core/styles";
const useProgressStyles = makeStyles(theme => ({
    wrapper: {
        margin: "2%",
    }, infoWrapper: {
        margin: "2%  3%",
    },
    mainWrapper: {
        margin: "2%",
        backgroundColor: "#F5F5F5"
    },
    dialogWrapper: {
        margin: "7% 5% "
    },
    description: {
        borderRadius: "5px",
        height: "max-content",
        fontSize: "15px",
        backgroundColor: "#F5F5F5",
        padding: "11px",
        whiteSpace: 'break-spaces'
    },
    tableWrapper: {
        width: "95%",
        margin: "1% 3%",
    },
    partCard: {
        borderRadius: "5px",
        padding: "5px 10px",
        "& p": {
            fontSize: "14px",
            padding: "3px",
        },

    }, root: {
        // borderRadius: 10,
        overflow: "hidden",
    },
    paper: {
        borderRadius: "5px",
        backgroundColor: "#F5F5F5",
        padding: theme.spacing(2),
    },
    headerBox: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px"
    },
    title: {
        fontSize: 18,
        display: "flex",
        alignItems: "center",
    }, subTiltle: {
        fontSize: 13,
        display: "flex",
        alignItems: "center",
    },
    actionNumber: {
        fontSize: 30,
        marginRight: theme.spacing(2),
    },
    field: {
        width: 100,
        marginRight: theme.spacing(1),
        "& input": {
            textOverflow: "ellipsis",
        },
    },
    ataField: {
        width: 60,
        marginRight: theme.spacing(1),
    },
    iconButton: {
        padding: 6,
        marginLeft: theme.spacing(0.5),
    },
    iconImg: {
        height: 18,
    },
    bookedOut: {
        borderColor: "#4D4F5C",
        borderRadius: "7px",
        minWidth: "20px",
        height: "30px",
        color: "#fff",
        backgroundColor: "#FF0202",
        width: "80px",
    },
    stockBtn2: {
        borderColor: "#4D4F5C",
        borderRadius: "7px",
        minWidth: "20px",
        height: "30px",
        color: "#fff",
        backgroundColor: "#4FC605",
        width: "80px",
    },
    tabs: {
        minHeight: "36px",
        "& .MuiTab-root": {
            borderRadius: "2px",
            minHeight: "36px",
            minWidth: "36px",
            boxShadow: "1px 1px 3px #00000044",
        },
        "& .MuiTabs-flexContainer": {
            gap: "0.75rem",
            padding: "0.25rem",
        },
        "& .MuiTab-textColorInherit": {
            opacity: 1,
        },
    }, modal: {
        "& .MuiDialog-paperWidthMd": {
            width: "45%",
            padding: '14px'
        },
    }, taskModal: {
        "& .MuiDialog-paperWidthMd": {
            width: "775px",
            padding: '14px'
        },
    },
    toolModal: {
        "& .MuiDialog-paperWidthMd": {
            width: "647px",
            padding: '14px'
        },
    },

    reOpenModal: {
        "& .MuiDialog-paperWidthMd": {
            width: "710px",
            padding: '14px'
        },
    }, unlockOpenModal: {
        "& .MuiDialog-paperWidthMd": {
            width: "810px",
            padding: '14px'
        },
    },
    titleDialog: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    warning1: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "13px",
        marginBottom: "20px",
    },
    warning: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "16px",
        marginBottom: "20px",
    },
    actionButtons: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    disableField: {
        pointerEvents: "none",
        backgroundColor: "#F5F5F5",
    },
    stageActionButtons: {
        textAlign: "right",
        marginTop: "30px",
        "& button": {
            // marginRight: "20px",
        },
    },
    checkboxStyle: {
        fontSize: "12px",
        marginBottom: "20px",
        marginRight: '20px',
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
    },
    readinessCard: {
        minHeight: '160px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0px 2px 10px rgba(0,0,0,0?.1)',
        borderRadius: "5px",
    }


}));

export default useProgressStyles;